import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type { SurveyState, SurveyResponse } from '@/types'

const initialState: SurveyState = {
  isOpen: false,
  hasCompletedSurvey: false,
  responses: [],
}

const surveySlice = createSlice({
  name: 'survey',
  initialState,
  reducers: {
    openSurvey: (state) => {
      state.isOpen = true
    },
    closeSurvey: (state) => {
      state.isOpen = false
    },
    completeSurvey: (state, action: PayloadAction<SurveyResponse[]>) => {
      state.responses = action.payload
      state.hasCompletedSurvey = true
      state.isOpen = false
    },
    resetSurvey: (state) => {
      state.isOpen = false
      state.hasCompletedSurvey = false
      state.responses = []
    },
    setSurveyData: (state, action: PayloadAction<Partial<SurveyState>>) => {
      if (action.payload.hasCompletedSurvey !== undefined) {
        state.hasCompletedSurvey = action.payload.hasCompletedSurvey
      }
      if (action.payload.responses) {
        state.responses = action.payload.responses
      }
    },
  },
})

export const { openSurvey, closeSurvey, completeSurvey, resetSurvey, setSurveyData } = surveySlice.actions

export default surveySlice.reducer
